import { render } from "./TransactionsView.vue?vue&type=template&id=358e2ebf&scoped=true"
import script from "./TransactionsView.vue?vue&type=script&lang=js"
export * from "./TransactionsView.vue?vue&type=script&lang=js"

import "./TransactionsView.vue?vue&type=style&index=0&id=358e2ebf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-358e2ebf"]])

export default __exports__